module.exports = __webpack_public_path__ + "static/media/Start Screeen-08.b9ca07e6.webp";